import queryNumber from './query-number.vue'

queryNumber.install = (Vue) =>{
  Vue.component(queryNumber.name,queryNumber);
};

export default {
  queryNumber
};



// WEBPACK FOOTER //
// ./src/components/query-number/index.js